import { Dispatch } from '@reduxjs/toolkit'
import {
  resetSelectedProgramAndYear,
  setPrograms,
  setProgramYears,
  setSelectedProgram,
  setSelectedProgramYear,
} from './slice.ts'
import {
  GlobalProgramProps,
  GlobalProgramsResponseProps,
  ProgramYearsProps,
} from '@/queries/program/schemas.ts'

export const startSetPrograms =
  (programs: GlobalProgramsResponseProps) => async (dispatch: Dispatch) => {
    dispatch(resetSelectedProgramAndYear())
    const programsData = programs.filter(
      ({ status }: { status: number }) => status == 1
    )
    dispatch(setPrograms(programsData))
    dispatch(setProgramYears(programsData[0].programs))

    const currentYear = new Date().getFullYear()
    const currentProgram =
      programsData[0].programs.find((p) =>
        p.period.includes(currentYear.toString())
      ) ?? programsData[0]?.programs[0]

    dispatch(setSelectedProgram(programsData[0]))
    dispatch(setSelectedProgramYear(currentProgram))
  }

export const startSelectGlobalProgram =
  (program: GlobalProgramProps) => async (dispatch: Dispatch) => {
    dispatch(setSelectedProgram(program))
    dispatch(setSelectedProgramYear(program.programs[0]))
  }

export const startSelectProgram =
  (program: GlobalProgramProps, years: ProgramYearsProps) =>
  async (dispatch: Dispatch) => {
    dispatch(setSelectedProgram(program))
    dispatch(setSelectedProgramYear(years))
  }

export const tempReset = () => async (dispatch: Dispatch) => {
  dispatch(resetSelectedProgramAndYear())
}

/* export const startValidateProgramsYears = (year: programTypeTemp, programs: GlobalProgramProps[]) => async (dispatch: Dispatch) => {
    const programsValidates = programs.map((m) => {
        if (m.period != year.period) {
            m.disabled = 1
        }
    })
    dispatch(setPrograms(programsValidates))
} */
